export const FAILED_TEXTS = {
  title: 'No pudimos suscribir tu APV',
  subtitle: 'Tu suscripción no se completó. Reintenta o ingresa más tarde.',
  subtitleWithoutRetries:
    'Tu suscripción no se completó. Ingresa más tarde o intenta por otro medio.',
};
